export const embedlyCookieTypes = ['marketing']
export const embedlyGlobalSelector = '.embedly-init'
export const embedlyCardDataAttribute = 'data-embedly-card'
export const embedlyCardSelector = `[${embedlyCardDataAttribute}]`

// Copied from embedly's docs.
/* eslint-disable */
function loadEmbedlyScript(w, d) {
  var id = 'embedly-platform',
    n = 'script'
  if (!d.getElementById(id)) {
    w.embedly =
      w.embedly ||
      function () {
        ;(w.embedly.q = w.embedly.q || []).push(arguments)
      }
    var e = d.createElement(n)
    e.id = id
    e.async = 1
    e.src = ('https:' === document.location.protocol ? 'https' : 'http') + '://cdn.embedly.com/widgets/platform.js'
    var s = d.getElementsByTagName(n)[0]
    s.parentNode.insertBefore(e, s)
  }
}
/* eslint-enable */

export function setupEmbedly() {
  loadEmbedlyScript(window, document)
  window.embedly('card', embedlyCardSelector)
  window.embedly('defaults', {
    cards: {
      key: '1cdf74229e6341f180e26198fe40468d'
    }
  })
}
